import DOMPurify from 'isomorphic-dompurify'

/**
 * Backend/CMS HTML rendered via dangerouslySetInnerHTML must pass through
 * here. Uses DOMPurify's default profile: keeps rich text and table markup,
 * strips scripts, event handlers, and javascript: URLs. For a stricter
 * per-context allowlist, see sanitizeAnswerHtml in src/lib/structured-data/faq.tsx.
 */
export function sanitizeBackendHtml(html: string): string {
  return DOMPurify.sanitize(html)
}
